import { useState } from "react";

// DEFECT-D-30: a user's chosen sort persists "within the session for that screen" — sessionStorage
// (survives navigating away and back, resets on browser close/new tab) keyed per screen, never a
// single global sort shared across unrelated screens.
export function useSortPersistence(screenKey, defaultSortBy, defaultSortDir = "desc") {
  const storageKey = `fitfrik:sort:${screenKey}`;
  const [state, setState] = useState(() => {
    try {
      const raw = sessionStorage.getItem(storageKey);
      if (raw) return JSON.parse(raw);
    } catch {
      // ignore corrupt/blocked storage — fall through to the default
    }
    return { sortBy: defaultSortBy, sortDir: defaultSortDir };
  });

  const setSort = (sortBy, sortDir) => {
    const next = { sortBy, sortDir };
    setState(next);
    try {
      sessionStorage.setItem(storageKey, JSON.stringify(next));
    } catch {
      // best-effort persistence only
    }
  };

  return { sortBy: state.sortBy, sortDir: state.sortDir, setSort };
}
